import React from 'react'
import { IOuterTableRef, TableDownloadProps, TableProps } from 'src/app/shared/components/common/new-table/table.model'
import { IOption } from 'src/app/shared/models/common.model'
import { IGetTransactions } from 'src/app/shared/models/Transaction.model'

export enum QuickFilter {
  ALL = 0,
  ACH = 1,
  CHECKS = 2,
  VOIDS = 3,
  STALE_DATED = 4,
  PAYEE_MATCH = 5,
  ISSUED = 6,
}

export interface IFilterState {
  selectedFilter: number
  disabledFilter: number[]
}

export interface SearchResultContextProps {
  filterState: IFilterState
  filterOptions: IOption[]
  loading: boolean
  transactionState: IGetTransactions.Response
  outerTableRef: React.RefObject<Partial<IOuterTableRef>>
  defaultParams: any
  setFilterState: React.Dispatch<React.SetStateAction<IFilterState>>
  setLoading: React.Dispatch<React.SetStateAction<boolean>>
  getTableName: (filter: number) => string
  handleSearch: (value: Partial<any>) => Promise<any>
  handleDownload: TableDownloadProps['handleDownload']
  generateCustomColumnDefs: TableProps['generateCustomColumnDefs']
}

export const defaultFilter: IFilterState = {
  disabledFilter: [],
  selectedFilter: QuickFilter.ALL,
}

export const SearchResultContext = React.createContext<SearchResultContextProps>({
  filterState: defaultFilter,
  filterOptions: [],
  loading: false,
  transactionState: {
    items: [],
    total: 0,
  },
  outerTableRef: null as any,
  defaultParams: {},
  setFilterState: () => {},
  setLoading: () => {},
  getTableName: () => '',
  handleSearch: () => Promise.resolve({}),
  handleDownload: () => Promise.resolve({}),
  generateCustomColumnDefs: () => [],
})

export const useSearchResultContext = () => React.useContext<SearchResultContextProps>(SearchResultContext)
